import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex h-full flex-col" }
const _hoisted_2 = {
  key: 0,
  class: "animate-spin h-10 w-10 m-auto text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_3 = {
  key: 1,
  class: "flex px-4 py-5 m-auto text-white"
}
const _hoisted_4 = {
  key: 2,
  class: "flex w-full flex-col px-4 py-5 space-y-6"
}
const _hoisted_5 = {
  key: 0,
  class: "flex flex-col w-full space-y-4"
}
const _hoisted_6 = { class: "font-medium text-lg text-brand-light-gray" }
const _hoisted_7 = { class: "flex justify-between w-full" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 1,
  class: "flex flex-col w-full space-y-4"
}
const _hoisted_10 = { class: "flex justify-between w-full" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 0,
  class: "text-sm my-auto"
}
const _hoisted_13 = {
  key: 1,
  class: "animate-spin h-5 w-5 mt-0.5 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_14 = {
  key: 2,
  class: "flex flex-col w-full space-y-4"
}
const _hoisted_15 = { class: "flex justify-between w-full" }
const _hoisted_16 = { class: "flex space-x-2" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 0,
  class: "text-sm my-auto"
}
const _hoisted_19 = {
  key: 1,
  class: "animate-spin h-5 w-5 mt-0.5 text-brand-black",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 0,
  class: "text-sm my-auto"
}
const _hoisted_22 = {
  key: 1,
  class: "animate-spin h-5 w-5 mt-0.5 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

import {
  alertController,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar, modalController,
  onIonViewWillEnter, toastController,
  useIonRouter,
} from '@ionic/vue';
import {inject, onMounted, onUnmounted, Ref, ref, watch} from 'vue';
import {UserInterface} from "@/interfaces/UserInterface";
import {UserBasicInformationInterface} from "@/interfaces/UserBasicInformationInterface";
import ApiService from "@/services/api/apiService";
import pluralize from "pluralize";
import UserListItem from "@/components/UserListItem.vue";
import ProfileSettingsPartnerContextMenu from "@/views/user/profile/ProfileSettingsPartnerContextMenu.vue";
import {Observable, ObservableEvent} from "@/services/observable/Observable";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProfileSettingsPartner',
  setup(__props) {

const user: Ref<UserInterface | undefined> = inject('user') as Ref<UserInterface | undefined>

const loading = ref(true)
const ionRouter = useIonRouter()
const busy = ref(false)
const acceptBusy = ref(false)

const partners: Ref<UserBasicInformationInterface[]> = ref([])
const partnerRequests: Ref<UserBasicInformationInterface[]> = ref([])
const partnerRequestsSent: Ref<UserBasicInformationInterface[]> = ref([])
const observer = ref()

onIonViewWillEnter(async () => {
  await getData()
  loading.value = false
})

onMounted(async ()=>{
  observer.value = Observable.subscribe(async (response: any) => {
    if (response.event === ObservableEvent.PartnersChanged) {
      partners.value = await getPartners()
    }
  })
})

onUnmounted(() => {
  observer.value?.unsubscribe()
})

const getData = async () => {
  const [i, ii, iii]: any = await Promise.allSettled([await getPartnerRequests(), await getPartners(), await getPartnerRequestsSent()])
  partnerRequests.value = i.value
  partners.value = ii.value
  partnerRequestsSent.value = iii.value
  loading.value = false
}

const getPartners = async () => {
  return await ApiService.User().getPartners()
}

const getPartnerRequests = async () => {
  return await ApiService.User().getPartnerRequests()
}

const getPartnerRequestsSent = async () => {
  return await ApiService.User().getPartnerRequestsSent()
}

const goBack = async () => {
  await ionRouter.back()
}

const search = async () => {
  ionRouter.navigate({
    name: 'ProfileSettingsPartnerSearch'
  }, 'forward', 'push')
}

const cancelRequest = async (requestedUser: UserBasicInformationInterface) => {

  const alert = await alertController.create({
    header: 'Cancel Request',
    subHeader: `Are you sure you want to cancel the relationship request with ${requestedUser.name}?`,
    buttons: [
      {
        text: 'Yes',
        role: 'destructive',
        handler: async () => {

          if (busy.value) return
          busy.value = true

          const index = partnerRequestsSent.value.findIndex((u) => u.id === requestedUser.id)
          partnerRequestsSent.value.splice(index, 1)
          await alert.dismiss()
          const toast = await toastController.create({
            header: 'Request Cancelled',
            message: 'Your partner request has been cancelled 👍',
            duration: 3000,
            position: 'bottom',
            color: 'primary'
          });
          await toast.present();
          await ApiService.User().removeFromPartners(requestedUser.id)

        }
      },
      {
        text: 'Cancel',
      }
    ]
  })

  await alert.present()
  await alert.onDidDismiss()
  busy.value = false

}

const rejectRequest = async (requestedUser: UserBasicInformationInterface) => {

  const alert = await alertController.create({
    header: 'Reject Request',
    subHeader: `Are you sure you want to reject the relationship request from ${requestedUser.name}?`,
    buttons: [
      {
        text: 'Yes',
        role: 'destructive',
        handler: async () => {

          if (busy.value) return
          busy.value = true

          const index = partnerRequests.value.findIndex((u) => u.id === requestedUser.id)
          partnerRequests.value.splice(index, 1)
          await alert.dismiss()
          const toast = await toastController.create({
            header: 'Request Rejected',
            message: `The partner request from ${requestedUser.name} has been rejected 👍`,
            duration: 3000,
            position: 'bottom',
            color: 'primary'
          });
          await toast.present();
          await ApiService.User().rejectPartnerRequest(requestedUser.id)

        }
      },
      {
        text: 'Cancel',
      }
    ]
  })

  await alert.present()
  await alert.onDidDismiss()
  busy.value = false

}

const acceptRequest = async (requestedUser: UserBasicInformationInterface) => {

  const alert = await alertController.create({
    header: 'Accept Request',
    subHeader: `Are you sure you want to accept the relationship request from ${requestedUser.name}?`,
    buttons: [
      {
        text: 'Yes',
        handler: async () => {

          if (busy.value) return
          busy.value = true
          acceptBusy.value = true

          await alert.dismiss()
          await ApiService.User().makePartnerRequest(requestedUser.id)
          await getData()
          const toast = await toastController.create({
            header: 'Accepted!',
            message: `You and ${requestedUser.name} are now linked as a couple ❤️`,
            duration: 3000,
            position: 'bottom',
            color: 'primary'
          });
          await toast.present();
          busy.value = false
          acceptBusy.value = false

        }
      },
      {
        text: 'Cancel',
        handler: () => {
          busy.value = false
        }
      }
    ]
  })

  await alert.present()

}

const partnerContext = async (partner: UserBasicInformationInterface) => {

  const sheet = await modalController.create({
    breakpoints: [0, 1],
    initialBreakpoint: 1,
    component: ProfileSettingsPartnerContextMenu,
    componentProps: {
      partner
    },
    mode: 'ios'
  })

  await sheet.present()
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButtons), {
                slot: "start",
                class: "mr-4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonButton), {
                    onClick: goBack,
                    class: "bg-brand-dark-gray rounded-md"
                  }, {
                    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                      _createElementVNode("svg", {
                        class: "",
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("path", {
                          d: "M6 11.9961H18",
                          stroke: "white",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }),
                        _createElementVNode("path", {
                          d: "M12 18L6 12L12 6",
                          stroke: "white",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        })
                      ], -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTitle), { class: "text-white font-medium text-2xl" }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode("Relationship", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_unref(IonButtons), { slot: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonButton), {
                    onClick: search,
                    class: "rounded-md"
                  }, {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createElementVNode("svg", {
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("path", {
                          d: "M21 21L16.514 16.506L21 21ZM19 10.5C19 12.7543 18.1045 14.9163 16.5104 16.5104C14.9163 18.1045 12.7543 19 10.5 19C8.24566 19 6.08365 18.1045 4.48959 16.5104C2.89553 14.9163 2 12.7543 2 10.5C2 8.24566 2.89553 6.08365 4.48959 4.48959C6.08365 2.89553 8.24566 2 10.5 2C12.7543 2 14.9163 2.89553 16.5104 4.48959C18.1045 6.08365 19 8.24566 19 10.5V10.5Z",
                          stroke: "#FFFFFF",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        })
                      ], -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), { class: "h-full" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (loading.value)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_2, [...(_cache[3] || (_cache[3] = [
                  _createElementVNode("circle", {
                    class: "opacity-25",
                    cx: "12",
                    cy: "12",
                    r: "10",
                    stroke: "currentColor",
                    "stroke-width": "4"
                  }, null, -1),
                  _createElementVNode("path", {
                    class: "opacity-75",
                    fill: "currentColor",
                    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  }, null, -1)
                ]))]))
              : _createCommentVNode("", true),
            (!loading.value && !partnerRequests.value.length && !partners.value.length && !partnerRequestsSent.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[4] || (_cache[4] = [
                  _createElementVNode("div", { class: "flex flex-col items-center space-y-6" }, [
                    _createElementVNode("svg", {
                      class: "h-16 w-16 text-brand-lime fill-current",
                      width: "24",
                      height: "25",
                      viewBox: "0 0 24 25",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, [
                      _createElementVNode("path", { d: "M17.5291 19.2339L17.4684 19.0516C15.8278 15.9225 12.5468 13.7959 8.77975 13.7959C5.01266 13.7959 1.73165 15.9225 0.091139 19.0212L0.0303799 19.2035C1.15437e-07 19.2643 0 19.3554 0 19.4465V20.206C0 20.6617 0.394936 21.0567 0.850633 21.0567H8.77975H16.7392C17.1949 21.0567 17.5899 20.6617 17.5899 20.206V19.4465C17.5899 19.3858 17.5595 19.2946 17.5291 19.2339Z" }),
                      _createElementVNode("path", { d: "M18.957 18.3531L18.9266 18.2923C17.9848 16.5303 16.6481 15.1024 15.0684 14.0695C15.919 13.6746 16.8911 13.4619 17.8937 13.4619C20.5063 13.4619 22.7544 14.9201 23.9089 17.0771L23.9696 17.1986C24 17.2594 24 17.3201 24 17.3505V17.867C24 18.2012 23.7266 18.4442 23.4228 18.4442H19.0177L18.957 18.3531Z" }),
                      _createElementVNode("path", { d: "M17.8937 11.5784C19.4541 11.5784 20.719 10.3134 20.719 8.75305C20.719 7.19267 19.4541 5.92773 17.8937 5.92773C16.3333 5.92773 15.0684 7.19267 15.0684 8.75305C15.0684 10.3134 16.3333 11.5784 17.8937 11.5784Z" }),
                      _createElementVNode("path", { d: "M8.74968 12.4896C11.1658 12.4896 13.1244 10.531 13.1244 8.11492C13.1244 5.69885 11.1658 3.74023 8.74968 3.74023C6.33361 3.74023 4.375 5.69885 4.375 8.11492C4.375 10.531 6.33361 12.4896 8.74968 12.4896Z" })
                    ]),
                    _createElementVNode("div", { class: "flex flex-col w-full items-center space-y-4 px-2" }, [
                      _createElementVNode("div", { class: "flex text-white text-2xl font-medium text-center" }, "Invites & Requests "),
                      _createElementVNode("div", { class: "text-brand-light-gray text-lg text-center" }, "Once you've liked your account with your partners your accounts will display as a couples account. ")
                    ])
                  ], -1)
                ]))]))
              : _createCommentVNode("", true),
            (!loading.value && (partners.value.length || partnerRequests.value.length || partnerRequestsSent.value.length))
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (partners.value && partners.value.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(pluralize)('Partner', partners.value.length)), 1),
                        _createElementVNode("div", _hoisted_7, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(partners.value, (u, userIndex) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: userIndex,
                              onClick: ($event: any) => (partnerContext(u)),
                              class: "flex justify-between w-full"
                            }, [
                              _createVNode(UserListItem, { user: u }, null, 8, ["user"]),
                              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "flex my-auto" }, [
                                _createElementVNode("svg", {
                                  width: "24",
                                  height: "24",
                                  viewBox: "0 0 24 24",
                                  fill: "none",
                                  xmlns: "http://www.w3.org/2000/svg"
                                }, [
                                  _createElementVNode("path", {
                                    d: "M5.52035 14.1598C6.71329 14.1598 7.68035 13.1928 7.68035 11.9998C7.68035 10.8069 6.71329 9.83984 5.52035 9.83984C4.32742 9.83984 3.36035 10.8069 3.36035 11.9998C3.36035 13.1928 4.32742 14.1598 5.52035 14.1598Z",
                                    fill: "#A5A7AF"
                                  }),
                                  _createElementVNode("path", {
                                    d: "M12.0008 14.1598C13.1938 14.1598 14.1608 13.1928 14.1608 11.9998C14.1608 10.8069 13.1938 9.83984 12.0008 9.83984C10.8079 9.83984 9.84082 10.8069 9.84082 11.9998C9.84082 13.1928 10.8079 14.1598 12.0008 14.1598Z",
                                    fill: "#A5A7AF"
                                  }),
                                  _createElementVNode("path", {
                                    d: "M18.4803 14.1598C19.6732 14.1598 20.6403 13.1928 20.6403 11.9998C20.6403 10.8069 19.6732 9.83984 18.4803 9.83984C17.2874 9.83984 16.3203 10.8069 16.3203 11.9998C16.3203 13.1928 17.2874 14.1598 18.4803 14.1598Z",
                                    fill: "#A5A7AF"
                                  })
                                ])
                              ], -1))
                            ], 8, _hoisted_8))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (partnerRequestsSent.value && partnerRequestsSent.value.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "font-medium text-lg text-brand-light-gray" }, "Pending", -1)),
                        _createElementVNode("div", _hoisted_10, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(partnerRequestsSent.value, (u, userIndex) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: userIndex }, [
                              _createVNode(UserListItem, { user: u }, null, 8, ["user"]),
                              _createElementVNode("div", {
                                onClick: ($event: any) => (cancelRequest(u)),
                                class: "text-white rounded-full border-2 font-medium py-1 pb-1.5 px-3 my-auto min-w-fit"
                              }, [
                                true
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Cancel Request"))
                                  : (_openBlock(), _createElementBlock("svg", _hoisted_13, [...(_cache[6] || (_cache[6] = [
                                      _createElementVNode("circle", {
                                        class: "opacity-25",
                                        cx: "12",
                                        cy: "12",
                                        r: "10",
                                        stroke: "currentColor",
                                        "stroke-width": "4"
                                      }, null, -1),
                                      _createElementVNode("path", {
                                        class: "opacity-75",
                                        fill: "currentColor",
                                        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                      }, null, -1)
                                    ]))]))
                              ], 8, _hoisted_11)
                            ], 64))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (partnerRequests.value && partnerRequests.value.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "font-medium text-lg text-brand-light-gray" }, "Requests", -1)),
                        _createElementVNode("div", _hoisted_15, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(partnerRequests.value, (u, userIndex) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: userIndex }, [
                              _createVNode(UserListItem, { user: u }, null, 8, ["user"]),
                              _createElementVNode("div", _hoisted_16, [
                                _createElementVNode("div", {
                                  onClick: ($event: any) => (acceptRequest(u)),
                                  class: "bg-white rounded-full border-2 border-white font-medium py-1 pb-1.5 px-3 my-auto"
                                }, [
                                  (!acceptBusy.value)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, "Accept"))
                                    : (_openBlock(), _createElementBlock("svg", _hoisted_19, [...(_cache[8] || (_cache[8] = [
                                        _createElementVNode("circle", {
                                          class: "opacity-25",
                                          cx: "12",
                                          cy: "12",
                                          r: "10",
                                          stroke: "currentColor",
                                          "stroke-width": "4"
                                        }, null, -1),
                                        _createElementVNode("path", {
                                          class: "opacity-75",
                                          fill: "currentColor",
                                          d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                        }, null, -1)
                                      ]))]))
                                ], 8, _hoisted_17),
                                _createElementVNode("div", {
                                  onClick: ($event: any) => (rejectRequest(u)),
                                  class: "text-white rounded-full border-2 font-medium py-1 pb-1.5 px-3 my-auto"
                                }, [
                                  true
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_21, "Reject"))
                                    : (_openBlock(), _createElementBlock("svg", _hoisted_22, [...(_cache[9] || (_cache[9] = [
                                        _createElementVNode("circle", {
                                          class: "opacity-25",
                                          cx: "12",
                                          cy: "12",
                                          r: "10",
                                          stroke: "currentColor",
                                          "stroke-width": "4"
                                        }, null, -1),
                                        _createElementVNode("path", {
                                          class: "opacity-75",
                                          fill: "currentColor",
                                          d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                        }, null, -1)
                                      ]))]))
                                ], 8, _hoisted_20)
                              ])
                            ], 64))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})